import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb3c7e50"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "current-supplier"
}
const _hoisted_2 = { class: "current-supplier__title h4" }
const _hoisted_3 = { class: "current-supplier__description" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-arrow-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Combobox = _resolveComponent("Combobox")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _directive_track = _resolveDirective("track")!

  return (_ctx.pageContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageContent.title), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.pageContent.description), 1),
        _withDirectives(_createVNode(_component_Combobox, {
          key: "select-supplier",
          modelValue: _ctx.selectedElectricitySupplier,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedElectricitySupplier) = $event)),
          class: "select-supplier",
          options: _ctx.selectableOptions(_ctx.listOfSuppliers),
          loading: _ctx.elecSuppliersLoading,
          "input-id": "select-supplier",
          placeholder: _ctx.pageContent.supplierPlaceholder,
          "no-matching-options-label": "No available suppliers",
          "error-message": _ctx.supplierErrorMessage,
          "has-error": _ctx.supplierHasError
        }, null, 8, ["modelValue", "options", "loading", "placeholder", "error-message", "has-error"]), [
          [_directive_track, `Click electricity supplier`]
        ]),
        _withDirectives(_createVNode(_component_Combobox, {
          key: "select-supplier-tariff",
          modelValue: _ctx.selectedElectricitySupplierTariff,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedElectricitySupplierTariff) = $event)),
          class: "select-supplier-tariff",
          options: _ctx.selectableOptions(_ctx.listOfTariffs),
          loading: _ctx.elecSuppliersTariffsLoading,
          "input-id": "supplier-tariff",
          placeholder: _ctx.pageContent.tariffPlaceholder,
          "no-matching-options-label": "No available tariffs",
          disabled: !_ctx.selectedElectricitySupplier,
          "error-message": _ctx.tariffErrorMessage,
          "has-error": _ctx.tariffHasError
        }, null, 8, ["modelValue", "options", "loading", "placeholder", "disabled", "error-message", "has-error"]), [
          [_directive_track, `Click electricity tariff`]
        ]),
        _createVNode(_component_AppButton, {
          class: "current-supplier__next-button",
          disabled: !_ctx.selectedElectricitySupplierTariff,
          "full-width": "",
          onClick: _ctx.next
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.pageContent.continueButtonCopy), 1),
            _hoisted_4
          ], undefined, true),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]))
    : _createCommentVNode("", true)
}